import type { ColumnDefResolved } from "@tanstack/vue-table";
import { createContext } from "reka-ui";
import { computed, shallowReactive } from "vue";

class ColumnsCollection {
	#columns = shallowReactive(new Map<string, ColumnDefResolved<any>>());

	#order = new Map<string, number>();

	set(id: string, col: ColumnDefResolved<any>) {
		if (!this.#order.has(id)) {
			const idx = this.#columns.size;
			this.#order.set(id, idx);
		}

		this.#columns.set(id, col);
	}

	values(): ColumnDefResolved<any>[] {
		const columns = Array.from(this.#columns.entries());
		columns.sort((a, b) => this.#getOrder(a[0]) - this.#getOrder(b[0]));

		return columns.map((c) => c[1]);
	}

	delete(id: string) {
		this.#columns.delete(id);
	}

	#getOrder(id: string) {
		return this.#order.get(id) || 0;
	}
}

type ColumnsContext = {
	columns: ColumnsCollection;
};

export const [injectColumnContext, provideColumnContext] = createContext<ColumnsContext>("Columns");

export function useColumns() {
	const columns = new ColumnsCollection();
	// const columns = shallowReactive(new Map<string, ColumnDef<any>>());

	provideColumnContext({ columns });

	return computed(() => columns.values());
}
